import React from 'react';

export const Footer: React.FC = () => {
  return (
    <footer
      style={{
        borderTop: '1px solid var(--line)',
        backgroundColor: 'var(--bg)',
        color: 'var(--ink-soft)',
        marginTop: 'auto',
      }}
    >
      <div
        className="container"
        style={{ padding: 'var(--space-4) var(--space-4)' }}
      >
        <div className="flex justify-between items-center flex-wrap gap-4">
          <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
            <span
              style={{
                fontFamily: 'var(--font-body)',
                fontSize: 'var(--text-sm)',
                fontWeight: 600,
                letterSpacing: '-0.01em',
                color: 'var(--ink)',
              }}
            >
              WebGen Engine
            </span>
            <span
              style={{
                fontFamily: 'var(--font-mono)',
                fontSize: '0.7rem',
                color: 'var(--ink-muted)',
                letterSpacing: '0.05em',
              }}
            >
              Policy-compliant website generator
            </span>
          </div>
          <div
            style={{
              fontFamily: 'var(--font-mono)',
              fontSize: '0.7rem',
              color: 'var(--ink-muted)',
              letterSpacing: '0.05em',
            }}
          >
            v1.0.0
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
